// removed by extract-text-webpack-plugin
module.exports = {"container":"pages-home-container","section":"pages-home-section"};


//////////////////
// WEBPACK FOOTER
// ./styles/pages/home.scss
// module id = 802
// module chunks = 246